<template>
    <div class="table-container">
        <div class="table-overflow">
            <div class="table" v-if="statistic.length">
                <div class="thead">
                    <div class="row header">
                        <div class="col name">Name</div>
                        <div class="col game-time">Game time</div>
                        <div class="col gems">Gems</div>
                        <div v-if="site.scoring === 0" class="col speed">Speed</div>
                        <div class="col in-game">Status</div>
                    </div>
                </div>
                <div class="tbody"
                    ref="tbody"
                    is="transition-group"
                    name="providers"
                    v-bind:css="false"
                    v-on:before-enter="beforeEnter"
                    v-on:enter="enter"
                    v-on:leave="leave"
                >
                    <div v-for="(game, index) in statistic" :style="{'margin-top': (index === 0 ? (43 * hideRow * -1) + 'px' : 0)}" class="row" :key="'game-' + game.id">
                        <div class="col name"><span class="num">{{ index + 1 }}.</span> {{ game.name }}</div>
                        <div class="col game-time">
                            <template v-if="game.game_time !== undefined && game.server_active_time_in !== null">
                                {{ game.game_time|timeToString }}
                            </template>
                            <template v-else> — </template>
                        </div>
                        <div class="col gems">
                            <template v-if="game.server_active_time_in !== null">
                                {{ game.gems1 }}
                            </template>
                            <template v-else> — </template>
                        </div>
                        <div v-if="site.scoring === 0" class="col speed">
                            <template v-if="game.server_active_time_in !== null && game.gems1 > 1">
                                {{ game.speed_rating }}
                            </template>
                            <template v-else> — </template>
                        </div>
                        <div :class="{
                            col      : true,
                            'in-game': true,
                            timeout  : $options.filters.statusName(game, 'bool'),
                            active   : (config.status.FINISH !== game.status),
                            finished : (config.status.FINISH === game.status)
                        }">
                            {{ game | statusName }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import config from "../config";

    import Velocity from 'velocity-animate';

    export default {
        name: "Statistic",
        data(){
            return {
                games:     {},
                statistic: [],
                config: config,
                site: {
                    S_NAME : null,
                    scoring: 0,
                },
                server_time: null,
                from: null,
                hideRow: 0
            };
        },
        metaInfo () {
            return {
                title: 'Statistic - ' + this.site.S_NAME,
            }
        },
        mounted() {

            const self = this;

            function getStatistics(){

                let http = {
                    from: self.from,
                    slug: self.slug,
                };

                let ids = Object.values(self.games).map(g => (g.ids !== undefined ? Object.values(g.ids) : g.id));

                if(!ids.length){
                    http.status = [config.status.FINISH, config.status.ACTIVE, config.status.PAUSE];
                } else {
                    http.statistic = [];
                    ids.forEach(i => {
                        if(Array.isArray(i))
                            http.statistic.push(...i);
                        else
                            http.statistic.push(i);
                    });
                }

                self.$http.get('statistic', {timeout: 3000, params: http}).then(resp => {

                    self.from        = resp.data.datetime;
                    self.site        = resp.data.site;
                    self.server_time = self.$moment(resp.data.server_time).unix();

                    if(resp.data.games.length){
                        resp.data.games.forEach(game => {
                            if(game.team_id !== null && game.team_id > 0) {
                                let id   = 'team-' + game.team_id;
                                let team =
                                        self.games[id] !== undefined && typeof self.games[id]
                                    ?
                                        self.games[id]
                                    :
                                        {
                                            status : game.status,
                                            server_active_time_in: game.server_active_time_in,
                                            game_time: game.game_time,
                                        };
                                game = {
                                    ...game,
                                    gems: {
                                        ...(typeof team.gems == 'object' ? self.games[id].gems : {}),
                                        [game.id]: game.gems,
                                    },
                                    ids: {
                                        ...(typeof team.ids == 'object' ? self.games[id].ids : {}),
                                        [game.id]: game.id,
                                    },
                                    name: game.team.name + ' team',
                                    id  : 'team-' + game.team_id,
                                    speed: {
                                        ...(typeof team.speed == 'object' ? self.games[id].speed : {}),
                                        [game.id]: game.speed_rating,
                                    },
                                    status: team.status !== game.status ? game.status : team.status,
                                    server_active_time_in: team.server_active_time_in !== null && team.server_active_time_in > game.server_active_time_in ? team.server_active_time_in : game.server_active_time_in,
                                    game_time: team.game_time > game.game_time ? team.game_time : game.game_time,
                                };
                            }
                            self.games = {
                                ...self.games,
                                [game.id]: {
                                    ...game,
                                    gems1: (typeof game.gems == 'object' ? Object.values(game.gems).reduce((a, b) => a + b, 0) : game.gems),
                                    server_time: self.$moment(game.server_active_time_in).unix()
                                }
                            };
                        });
                    }

                    setTimeout(getStatistics, 1000);

                }).catch(() => {
                    setTimeout(getStatistics, 2000);
                });
            }

            getStatistics();

            function checkStat(){
                self.hideRow++;
                if((self.hideRow + 10) > self.statistic.length){
                    self.hideRow = 0;
                }
                setTimeout(checkStat, 2500);
            }

            setTimeout(checkStat, 3500);
        },
        props: {
            slug: {
                type:    [String],
                default: null
            },
        },
        watch: {
           server_time  (n) {
               let self = this;
               self.statistic = Object
                   .values(self.games)
                   .filter(game => [config.status.ACTIVE, config.status.PAUSE, config.status.FINISH].indexOf(game.status) >= 0)
                   .map(game => {
                       if(self.site.scoring === 0){
                           if([config.status.ACTIVE, config.status.PAUSE].indexOf(game.status) >= 0){
                               if(game.gems1 > 1){
                                   game.speed_rating = Math.round((game.gems1 / (n - game.server_time)) * 3600);
                               } else {
                                   game.speed_rating = 0;
                               }
                           } else {
                               if(game.speed !== undefined){
                                   let speed  = Object.values(game.speed);
                                   game.speed_rating = Math.round(speed.reduce((a, b) => a + b, 0) / speed.length);
                               }
                           }
                       }

                       if([config.status.ACTIVE, config.status.PAUSE].indexOf(game.status) >= 0){
                           game.game_time = n - game.server_time;
                       } else {
                           game.game_time = self.$moment(game.server_active_time_out).unix() - self.$moment(game.server_active_time_in).unix();
                       }

                       return game;
                   })
                   .sort((a, b) => {
                       if(self.site.scoring === 0)
                           return a.speed_rating < b.speed_rating ? 1 : -1;
                       else
                           return a.gems < b.gems ? 1 : -1;
                   });
           },
        },
        methods: {
            beforeEnter: function (el) {
                el.style.opacity = 0;
                el.style.height  = 0;
            },
            enter: function (el, done) {
                let delay = el.dataset.index * 100;
                setTimeout(function () {
                    Velocity(
                        el,
                        { height: '43px', opacity: 1, },
                        { complete: done }
                    )
                }, delay)
            },
            leave: function (el, done) {
                let delay = el.dataset.index * 100;
                setTimeout(function () {
                    Velocity(
                        el,
                        { height: '43px', opacity: 0, },
                        { complete: done }
                    )
                }, delay)
            }
        }
    }
</script>